import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AccordionModule } from '@epicuro-next/ataraxia/accordion';
import { AnchorModule } from '@epicuro-next/ataraxia/anchor';
import { IconsModule } from '@epicuro-next/ataraxia/icons';
import { MediaModule } from '@epicuro-next/ataraxia/media';
import { PageNotFoundModule } from '@epicuro-next/ataraxia/page-not-found';
import { DataMerchandiseModule } from '@epicuro-next/data/merchandise';
import { DynamicComponentsModule } from '@epicuro-next/platform/dynamic-components';
import { ConfigStripStateModule } from '@epicuro-next/state/config-strip-state';
import { ProductListStoreModule } from '@epicuro-next/state/product-list-state';
import { RouterStoreModule } from '@epicuro-next/state/router-store';
import { StoreModule } from '@ngrx/store';

import { BannerComponent } from './banner/banner.component';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { LandingLinkService } from './service/link.service';
import { TileComponent } from './tile/tile.component';

@NgModule({
  imports: [
    CommonModule,
    StoreModule,
    IconsModule,
    AccordionModule,
    AnchorModule,
    MediaModule,
    DynamicComponentsModule,
    PageNotFoundModule,
    RouterModule.forChild([
      {
        path: '',
        component: LandingPageComponent,
      },
    ]),
    DataMerchandiseModule,
    RouterStoreModule,
    ConfigStripStateModule,
    ProductListStoreModule,
    BannerComponent,
  ],
  declarations: [LandingPageComponent, TileComponent],
  providers: [LandingLinkService],
})
export class FeaturesLandingModule {}
